import type { HTMLSerializeOptions } from '@lumapps/wrex/serialization/html/toHTML/types';

export const TABLE_ELEMENTS: HTMLSerializeOptions['elements'] = {
    table: (_, children) => `<table>${children}</table>`,
    tr: (_, children) => `<tr>${children}</tr>`,
    td: (_, children) => `<td>${children}</td>`,
};
